// exports.CH_PLAY_DOWNLOAD_URL = 'https://play.google.com/store/apps/details?id=com.sag1.tailoc';
exports.CH_PLAY_DOWNLOAD_URL = 'https://www.tailoc68.vn/thong-tin/huong-dan-download';
exports.APP_STORE_DOWNLOAD_URL =
  'https://apps.apple.com/vn/app/t%C3%A0i-l%E1%BB%99c-mua-h%E1%BB%99-vietlott/id1536375131?l=vi';
